import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { HousekeepingPage } from '@/features/hospitality/pages/HousekeepingPage'

const searchSchema = z.object({
  tab: z.enum(['tasks', 'transfer', 'stock', 'stock-takes']).catch('tasks'),
})

export const Route = createFileRoute('/_app/hospitality/housekeeping')({
  validateSearch: searchSchema,
  component: HousekeepingPage,
})
